/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/* eslint-disable react-hooks/exhaustive-deps */
import { Transition } from '@az/starc-ui'
import { FunctionComponent, PropsWithChildren, useEffect, useState } from 'react'
import AnimateHeight from 'react-animate-height'

type Duration = 'fast' | 'medium' | 'slow'
type CustomDuration = { height?: Duration; appear?: Duration }
interface HeightTransitionProps extends PropsWithChildren {
  show: boolean
  duration?: Duration | CustomDuration
}

export const HeightTransition: FunctionComponent<HeightTransitionProps> = ({
  show,
  duration,
  children,
}) => {
  const [transition, setTransition] = useState(show)
  const [height, setHeight] = useState(show)

  useEffect(() => {
    if (show === true) {
      setTransition(true)
    } else {
      setTransition(false)
      setHeight(false)
    }
  }, [show])

  useEffect(() => {
    if (show === true) {
      if (transition === true) {
        setHeight(true)
      }
    }
  }, [transition])

  const getDuration = (type: 'height' | 'appear') => {
    if (duration == undefined) return undefined
    if ((duration as CustomDuration).appear || (duration as CustomDuration).height) {
      if (type == 'height') return (duration as CustomDuration).height
      else return (duration as CustomDuration).appear
    } else {
      return duration as Duration
    }
  }

  return (
    <AnimateHeight
      height={!show ? 0 : height ? 'auto' : 0}
      duration={
        getDuration('height') == undefined
          ? undefined
          : duration == 'fast'
          ? 150
          : duration == 'medium'
          ? 250
          : 300
      }
    >
      <Transition visible={!show ? false : transition} appear duration={getDuration('appear')}>
        {children}
      </Transition>
    </AnimateHeight>
  )
}

// function delay(ms: number) {
//   return new Promise(resolve => setTimeout(resolve, ms))
// }
